export const queryKeys = {
  session: ['session'] as const,
  branding: (tenantSlug?: string) => ['branding', tenantSlug ?? 'default'] as const,
  csrf: ['csrf'] as const,
};
